import { STUDENT_EXPENSES_URL } from 'constants/config';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

import type { Currency } from '../../models';
import { preOrders } from './preOrders/preOrders';

enum OrderStatuses {
  cancelled = 'cancelled',
  pending = 'pending',
  delivered = 'delivered',
  verifying = 'verifying',
  verified = 'verified',
  received = 'received',
  created = 'created',
}
enum OrderTypes {
  forexcard = 'forexcard',
  remittance = 'remittance',
}
type OrderStatus = keyof typeof OrderStatuses;
type OrderType = keyof typeof OrderTypes;

export type StudentExpensesPayment = {
  createdAt: Date;
  purchase: {
    value: number;
    currency: Currency;
  };
  reference: string;
  status: OrderStatus;
  type: OrderType;
  beneficiary?: {
    student?: {
      firstName: string;
      lastName: string;
    };
  };
  url: string;
};

export type StudentExpensesPaymentsData = {
  payments: StudentExpensesPayment[];
  pagination: {
    totalElements: number;
    totalPages: number;
    perPage: number;
    currentPage: number;
  };
};

export const studentExpenses = {
  payments: ({
    page = 0,
    perPage = 5,
  }: {
    page?: number;
    perPage?: number;
  } = {}): Promise<StudentExpensesPaymentsData> => {
    const paramsObj = {
      page: `${page}`,
      perPage: `${perPage}`,
    };
    const searchParams = new URLSearchParams(paramsObj);

    const url = `${STUDENT_EXPENSES_URL}/payments?${searchParams.toString()}`;
    const options = {
      method: 'GET',
    };

    return fetchWithAuthentication(url, options);
  },

  preOrders: preOrders,
};
